import React from 'react';
import { testimonials } from '../data/mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 px-6 bg-emerald-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-medium text-sm uppercase tracking-wider mb-4 block">
            Social Proof
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Creators Love Crevix
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            See what early creators are saying about their experience.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all hover:-translate-y-1 group"
            >
              {/* Quote Icon */}
              <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mb-6 group-hover:bg-emerald-200 transition-colors">
                <Quote className="w-5 h-5 text-emerald-600" />
              </div>

              {/* Quote Text */}
              <p className="text-slate-700 leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-semibold text-slate-900">{testimonial.name}</p>
                  <p className="text-slate-500 text-sm">
                    {testimonial.niche}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
